import { memo } from "react";
// @mui
import { Stack, Tooltip, Button } from "@mui/material";
// utils
import { hideScrollbarY } from "../../../utils/cssStyles";
//
import { NavSectionProps, NavListProps } from "../types";
import { NavLink } from "react-router-dom";

// ----------------------------------------------------------------------

function NavSectionHorizontal({ data, sx, ...other }: NavSectionProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mx: "auto",
        ...hideScrollbarY,
        ...sx,
      }}
      {...other}>
      {data.map((group) => (
        <Items key={group.subheader} items={group.items} />
      ))}
    </Stack>
  );
}

export default memo(NavSectionHorizontal);

// ----------------------------------------------------------------------

type ItemsProps = {
  items: NavListProps[];
};

function Items({ items }: ItemsProps) {
  return (
    <>
      {items.map((item) => (
        <Tooltip
          key={item.title}
          title={item.disabled ? "Access restricted" : ""}
          placement="bottom">
          <span>
            <Button
              component={item.disabled ? "div" : NavLink}
              to={item.disabled ? undefined : item.path}
              startIcon={item.icon}
              disabled={item.disabled}
              sx={{
                opacity: item.disabled ? 0.5 : 1,
                cursor: item.disabled ? "not-allowed" : "pointer",
                color: item.disabled ? "text.disabled" : "text.primary",
                textTransform: "capitalize",
                fontWeight: 500,
              }}>
              {item.title}
            </Button>
          </span>
        </Tooltip>
      ))}
    </>
  );
}
